import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import TextInput from '../inputs/TextInput';
import Button from '../buttons/Button';
import ErrorMessage from '../message/ErrorMessage';
import { snackBar } from 'highed';
import { postDivision } from '../../api/cloudApiGenerated';

class DivisionModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.onSearchInputChange = this.onSearchInputChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.createNewDivision = this.createNewDivision.bind(this);

    this.state = {
      name: '',
      selectValue: '0',
      newTeamError: '',
      team: undefined,
    };
  }

  onSearchInputChange(event) {
    this.setState({
      name: event.target.value,
    });
  }

  createNewDivision() {
    if (this.state.name === '') {
      this.setState({ newTeamError: 'A subteam name is mandatory.' });
      return;
    }
    postDivision({ name: this.state.name, team_id: this.props.team.id }).then(() => {
      snackBar('Subteam added');
      this.props.reloadDivisions(this.props.team, this.props.profile);
      this.props.close();
    });
  }

  onChange(element) {
    this.setState({ selectValue: element });
  }

  render() {
    return (
      <Modal
        className="hc-modal-content"
        overlayClassName="hc-modal-overlay"
        appElement={document.querySelector('.page-container')}
        parentSelector={this.props.parentSelector}
        isOpen={this.props.isOpen}
        onRequestClose={this.props.close}
        contentLabel="New Team"
      >
        <ErrorMessage error={this.state.newTeamError} />
        <h3>Add a subteam</h3>
        {this.props.team && (
          <p>
            {' '}
            This will add a new subteam to the team: <b>{this.props.team.name}</b>{' '}
          </p>
        )}
        <div>
          <label htmlFor="name"> Name: </label>
        </div>
        <TextInput
          name="name"
          value={this.state.name}
          onChange={this.onSearchInputChange}
          placeholder="Name"
          autoFocus={true}
        />
        <br />
        <Button buttonText="Add" buttonClass="bulk-action-btn" onClick={this.createNewDivision} />{' '}
        <Button buttonText="Cancel" onClick={this.props.close} buttonClass={'bulk-action-btn grey'} />
      </Modal>
    );
  }
}

DivisionModal.propTypes = {
  isOpen: PropTypes.bool,
  parentSelector: PropTypes.func,
  close: PropTypes.func,
  reloadDivisions: PropTypes.func,
  team: PropTypes.object,
  profile: PropTypes.object,
};

export default DivisionModal;
